import React from 'react';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';
import Text from '@/components/ui/Text';

interface ScoreProgressProps {
  hasAnyScores?: boolean;
  isTurnedIn?: boolean;
  maxPoints: number;
  points?: number;
}

export const ScoreProgress = ({ hasAnyScores, isTurnedIn, points, maxPoints }: ScoreProgressProps) => {
  // Show dash ONLY if no questions scored AND section not turned in
  const shouldShowDash = !hasAnyScores && !isTurnedIn;

  return (
    <Text
      className={cn(
        'tw-border tw-border-solid tw-border-med-grey tw-rounded',
        'tw-py-1 tw-px-2 tw-my-0 tw-ml-auto tw-mr-4',
        'tw-text-tci-black tw-bg-light-grey',
      )}
      size="xs"
      weight="bold"
      xxl={{ size: 'md' }}
    >
      {shouldShowDash ? ' - ' : parseFloat((points ?? 0).toFixed(2))}/{maxPoints} {I18n.t('points')}
    </Text>
  );
};
